<template>
  <div class="ticketlist">
    <div class="headerImage">
      <img src="~@/assets/image/common/common_header.png" alt="" />
      <div class="btn">
        <div class="zh" @click="selectZh">中文</div>
        <div style="color:#fff">|</div>
        <div class="en active" @click="selectEn">English</div>
      </div>
    </div>
    <state v-if="$store.state.ticketResources.length" :resourcesObj="$store.state.ticketResources[0]"></state>
    <selector select="selector-about"></selector>
    <router-view></router-view>
    <policyNotice v-if="$store.getters.checkPolicyEnglish"></policyNotice>
    <indexNotice v-if="$store.getters.checkReminder"></indexNotice>
  </div>
</template>

<script>
import state from "@/components/entry/buyTicketHomeEn/state/index.vue";
import policyNotice from "@/components/entry/buyTicketHomeEn/policyNotice/index.vue";
import selector from "@/components/entry/buyTicketHomeEn/selector/index.vue";
import personalCenter from "@/components/entry/buyTicketHomeEn/personalCenter/index.vue";
export default {
  name: "buyTicketHomeEn",
  components: {
    state,
    selector,
    policyNotice,
    personalCenter
  },
  created() {
    localStorage.setItem('language', 'en_US')
  },
  methods:{
    selectZh(){
      localStorage.setItem('language', 'zh_CN')
      this.$router.push('/buyTicketHome/0/0')
    },
    selectEn() {
      localStorage.setItem('language', 'en_US')
    }
  }
};
</script>

<style scoped lang='less'>
.ticketlist{
  background: #3B6D9C;
}
.headerImage{
  position:relative;
  .btn{
    position:absolute;
    top:0.3rem;
    right: 0.2rem;
    display: flex;
    width: 3rem;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.2);
    font-size: 0.35rem;
    font-weight: 600;
    z-index: 999;
    color:rgba(255, 255, 255, 0.6);
    // background-color: rgba(255, 255, 255, 0.3);
    // padding: 0.0666rem;
    border-radius: 0.2rem;
    box-sizing: border-box;
    .zh{
      width:50%;
      text-align: center;
      padding: 0.0666rem;
    }
    .active{
      // background-color: rgba(0, 0, 0, 0.6);
      color:#fff;
      border-radius: 0.2rem;
    }
    .en{
      width:50%;
      text-align: center;
      padding: 0.0666rem;
    }
  }
}
</style>
